import React from "react";
import { fuelTypeData } from "../../../../data/category/inputData";
import CheckboxFilter from "../Common/CheckboxFilter";

const FuelType = () => {
  return (
    <CheckboxFilter
      title="Fuel Type"
      filterData={fuelTypeData}
      filterName="fuelType"
    />
  );
};

export default FuelType;
